<div class="stock-header">
  <button
    class="stock-info"
    [disabled]="!companyAvailable"
    (click)="companyClicked.emit()"
    [attr.aria-label]="(stockName ? stockName + ': ' : '') + 'Unternehmensprofil öffnen'"
  >
    @if (stockLogo) {
      <img [src]="stockLogo" alt="" width="24" height="24" class="stock-logo" />
    }
    <span class="stock-name">{{ stockName }}</span>
    <img [src]="companyIconSrc()" alt="" width="24" height="24" class="company-icon" />
  </button>

  <div class="trailing">
    <div class="price-block">
      @if (price !== null && price !== undefined) {
        <div
          class="price-values"
          [class.positive]="prevPrice !== null && prevPrice !== undefined && price > prevPrice"
          [class.negative]="prevPrice !== null && prevPrice !== undefined && price < prevPrice"
        >
          <p class="price">{{ price | priceScale }}</p>
          @if (prevPrice !== null && prevPrice !== undefined) {
            <p class="change">{{ price | percentageChange: prevPrice }}</p>
          }
        </div>
      }
    </div>

    <button class="close-btn" (click)="closeClicked.emit()" aria-label="Schließen">
      <img [src]="closeIconSrc()" alt="" width="36" height="36" />
    </button>
  </div>
</div>
